import { Subject } from "rxjs";

export class AutoCompleteStatus {
  /**
   * autoComplete 欄位修改前的值。
   * 用來判斷 autoComplete 元件輸入值有沒有改變。
   */
  autoCompletePreviousValue: Map<string, string> = new Map<string, string>();

  /**
   * autoComplete 欄位取回資料的值。
   */
  autoCompleteCompleteValue: Map<string, string> = new Map<string, string>();

  /**
   * 執行按鈕動作時，用來判斷是否需要等 autoComplete completeMethod 完成。
   */
  waitAutoComplete: Map<string, boolean> = new Map<string, boolean>();

  /**
   * autoComplete completeMethod 完成通知。
   */
  autoCompleteSubject$ = new Subject<void>();

  /**
   * autoComplete 是否按下清除。
   */
  // isCleared: boolean = false;

  /**
   * 記錄清除的是哪個欄位，避免 autoComplete completeMethod 清除到不該清除的欄位。
   */
  isClearedFormControlName: string = '';
}
